import './vehicle.scss';

import { Outlet } from "react-router-dom";

import { FilterVehicleTransactionProvider } from "../vehicle-transaction/filter-vehicle-transaction/filter-vehicle-transaction.context"
import { FilterVehicleProvider } from "./filter-vehicle/filter-vehicle.context";

export function Vehicle() {
  return (
    <div id="ShellVehicle" className="vehicle">
      <FilterVehicleProvider>
        <FilterVehicleTransactionProvider>
          <Outlet />
        </FilterVehicleTransactionProvider>
      </FilterVehicleProvider>
    </div>
  );
}

export default Vehicle;
